/* eslint-disable indent */
import { initMap } from "../tabs-map.js";
import { API } from "../../../services/api/endpoints/index.js";
import { generateDoctorCardHTML, generateDoctorLoaderCardHTML } from "../doctor.js";
import { parseCenterInfoFromHTMLStr } from "../util.js";
import { openAppointmentPopup } from "../popup.js";
import { initMiniatures } from "./miniatures.js";
import { notifyErrorWithText } from "../../../modules/notifications/index.js";

/**
 *
 * @param {{
        address: string,
        phone: string,
        workHours: string,
        serviceType: string,
        href: string,
        city: string
    }[]} cities
 */
function generateChooseCityAppointmentPopup(cities) {
    const modal = document.createElement("div");

    modal.classList.add("modal");

    modal.id = "appointment-choose";

    modal.innerHTML = `
        <div data-close-modal class="modal__overlay"></div>
        <div class="modal__inner modal-center__inner">
            <button class="modal__close modal-center__close" data-close-modal>
                <i class="modal__close-icon icon-close"></i>
            </button>
            <div class="modal-center__header">
                <h4 class="h4 modal-center__title">
                    Выберите в какой филиал вы хотите записаться
                </h4>
            </div>


            <div class="modal-center__content">
                <div class="appointment-choose__buttons">
                    ${cities.map((cityInfo) => (
        `<button data-appointment="${cityInfo.serviceType}" class="appointment-choose__button btn--M btn-secondary-light">
                                ${cityInfo.city}
                            </button>`
    )).join(" ")
        }
                </div>
            </div>
        </div>
    `;

    const buttons = modal.querySelectorAll("[data-appointment]");

    const closeButtons = modal.querySelectorAll("[data-close-modal");

    closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", () => window.closeModals());
    });

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            window.closeModals();
            openAppointmentPopup(button.dataset.appointment);
        });
    });

    return modal;
}

export async function initSkinDiagnosticCenterCities(isOnline = false) {
    const main = document.querySelector(".skin-diagnostic-center.skin-diagnostic-center--cities");

    initMiniatures();

    if (isOnline) {
        const newTitleText = "Бесплатная онлайн консультация";

        const title = main.querySelector(".section-about__content .h2");

        title.innerText = newTitleText;

        const aboutText = main.querySelector(".section-about__text");

        const offlineAppointment = main.querySelector(".section--offline-appointment");

        const card = offlineAppointment.querySelector(".card:nth-child(2)");

        const breadcrumbLastItem = main.querySelector(".breadcrumbs__item:last-child");

        const onlineServiceLinkHref = "/skin-diagnostic-center/online/";

        const onlineServiceLinkEl = document.createElement("a");

        onlineServiceLinkEl.href = onlineServiceLinkHref;

        onlineServiceLinkEl.innerText = newTitleText;

        const toast = main.querySelector(".section--appointment .card--toast");

        toast.style.display = "none";

        breadcrumbLastItem.innerHTML = "";

        breadcrumbLastItem.append(onlineServiceLinkEl);

        aboutText.replaceWith(card);

        offlineAppointment.parentNode.style.display = "none";
    }

    try {
        const { points: { features } } = await initMap();

        localStorage.setItem("skinDiagnosticCenterFeatures", JSON.stringify(features));

        const doctorsListEl = document.querySelector(".js-slider-doctors-list .swiper-wrapper");

        if (!doctorsListEl) return;

        const citiesInfo = [];

        const doctorsCards = [];

        const fetchAndapperndDoctorByFeature = async (feature, index) => {
            const centerInfo = {
                ...parseCenterInfoFromHTMLStr(feature.properties.balloonContentBody),
                city: feature.city,
            };

            citiesInfo.push(centerInfo);

            try {
                for (let i = 0; i <= 4; i++) {
                    const loaderCard = generateDoctorLoaderCardHTML(`feature-${feature.id}`);
                    doctorsListEl.prepend(loaderCard);
                }

                const scheduleResponse = await API.yclients.getScheduleBranch(
                    centerInfo.serviceType,
                );

                const schedule = await scheduleResponse.json();

                const loaders = document.querySelectorAll(`[data-id="feature-${feature.id}"]`);

                loaders.forEach((l) => {
                    l.remove();
                });

                if (!schedule.items) {
                    return;
                }

                Object.values(schedule.items).forEach((item) => {
                    const employee = item.employee;

                    if (employee.name !== "Лист ожидания") {
                        const reviews = item.reviews;

                        const doctorCard = generateDoctorCardHTML({
                            doctor: { ...employee, info: item.info },
                            city: feature.city,
                            address: item.info.addresses || feature.add_name,
                            serviceType: centerInfo.serviceType,
                            reviews,
                            metro: (item.info.addresses
                                && Object.values(item.info.addresses).length > 1)
                                ? []
                                : feature.metro,
                        });

                        const doctorById = doctorsCards
                            .find((card) => card.doctor.id === employee.id);

                        const doctorByUserId = employee.user_id !== null ? doctorsCards
                            .find((card) => card.doctor.user_id === employee.user_id) : undefined;

                        if (!doctorById && !doctorByUserId) {
                            doctorsCards.push({ doctor: employee, card: doctorCard });
                            if (doctorsListEl.querySelectorAll(".doctor-card").length > 4) {
                                doctorsListEl.append(doctorCard);
                            } else {
                                doctorsListEl.prepend(doctorCard);
                            }
                        } else {
                            const doctorId = doctorById
                                ? doctorById.doctor.id
                                : doctorByUserId.doctor.id;

                            const popupEl = document.querySelector(`#popup--doctor-${doctorId}`);
                            const cardEl = doctorsListEl.querySelector(`#card--doctor-${doctorId}`);

                            const cardDescription = cardEl ? cardEl.querySelector(".description"): undefined

                            let description = "";

                            if (doctorById && doctorById.doctor.description) {
                                description = doctorById.doctor.description;
                            }
                            if (doctorByUserId && doctorByUserId.doctor.description) {
                                description = doctorByUserId.doctor.description;
                            }
                            if (employee && employee.description) {
                                description = employee.description;
                            }

                            const popupDescriptionEl = popupEl ? popupEl.querySelector(".description") : undefined;

                            if (popupEl && description && popupDescriptionEl) {
                                popupDescriptionEl.innerHTML = description;
                            }

                            if (cardEl && description && cardDescription) {
                                cardDescription.parentElement.style.display = "flex";
                                const descriptionEl = document.createElement("p");
                                descriptionEl.innerHTML = description;
                                cardDescription.innerHTML = descriptionEl.innerText;
                                descriptionEl.remove();
                            }
                        }
                    }
                });
            } catch (error) {
                notifyErrorWithText(error.message);
                const loaders = document.querySelectorAll(`[data-id="feature-${feature.id}"]`);

                loaders.forEach((l) => {
                    l.remove();
                });
            }
        };

        if (isOnline) {
            for (let i = 0; i <= 4; i++) {
                const loaderCard = generateDoctorLoaderCardHTML("feature-online");
                doctorsListEl.append(loaderCard);
            }
            const scheduleResponse = await API.yclients.getScheduleBranch(
                "online",
            );

            const schedule = await scheduleResponse.json();

            if (!schedule.items) {
                doctorsListEl.closest(".section").remove();
                return;
            }

            const loaders = document.querySelectorAll('[data-id="feature-online"');

            loaders.forEach((l) => {
                l.remove();
            });

            Object.values(schedule.items).forEach((item) => {
                const employee = item.employee;
                if (employee.name !== "Лист ожидания") {
                    const reviews = item.reviews;

                    const doctorCard = generateDoctorCardHTML({
                        doctor: { ...employee, info: item.info },
                        serviceType: "online",
                        reviews,
                        city: "online",
                    });

                    if (!doctorsCards
                        .find((card) => card.doctor.id === employee.id)
                        && !doctorsCards
                            .find((card) => card.doctor.user_id === employee.user_id)) {
                        doctorsCards.push({ doctor: employee, card: doctorCard });
                        if (doctorsListEl.querySelectorAll(".doctor-card").length > 4) {
                            doctorsListEl.append(doctorCard);
                        } else {
                            doctorsListEl.prepend(doctorCard);
                        }
                    }
                }
            });
        } else {
            await Promise.all(features.map(fetchAndapperndDoctorByFeature));

            const scheduleResponse = await API.yclients.getScheduleBranch(
                "online",
            );

            const schedule = await scheduleResponse.json();

            if (schedule.items) {
                Object.values(schedule.items).forEach((item) => {
                    const employee = item.employee;
                    if (employee.name !== "Лист ожидания") {
                        const reviews = item.reviews;

                        const doctorCard = generateDoctorCardHTML({
                            doctor: { ...employee, info: item.info },
                            serviceType: "online",
                            reviews,
                            city: "online",
                        });

                        if (!doctorsCards
                            .find((card) => card.doctor.id === employee.id)
                            && !doctorsCards
                                .find((card) => card.doctor.user_id === employee.user_id)) {
                            doctorsCards.push({ doctor: employee, card: doctorCard });
                            if (doctorsListEl.querySelectorAll(".doctor-card").length > 4) {
                                doctorsListEl.append(doctorCard);
                            } else {
                                doctorsListEl.prepend(doctorCard);
                            }
                        }
                    }
                });
            }
        }

        if (main) {
            main.append(generateChooseCityAppointmentPopup(citiesInfo));

            const chooseAppointmentButton = main.querySelector("[data-appointment='choose']");

            chooseAppointmentButton.addEventListener("click", () => window.openModal("#appointment-choose"));
        }
    } catch (error) {
        notifyErrorWithText(error.message);
    }
}
